/*
    Přidání štítku
*/
import React, { Fragment, useState } from "react";
import { useMutation, useQuery } from "@apollo/client";
import Loading from "../../../GlobalComponents/Loading";
import Error from "../../../GlobalComponents/Error";
import Modal from "react-modal";
import { ADD_EDIT_ORGANISER, GET_ORGANISER } from "../Queries/organiser";
import OrganiserLib from "../Library/organiser";
import Notification from "../../../Library/notification";
import Helper from "../../../Library/helper";
import translate from "../../Translations/index";
import EditOrganiserLogo from "./EditOrganiserLogo";
import OrganiserContactList from "./OrganiserContactList";
import OrganiserAdminUserList from "./OrganiserAdminUserList";

const AddEditOrganiser = (props) => {
    const organiserLib = new OrganiserLib(props);
    const [selectedTab, setTab] = useState(1);

    const [formData, setFormData] = useState({
        organiserID: props.selectedOrganiserID,
        name: "",
        countryID: "0",
        sportIDs: [],
    });

    const {
        loading: getLoading,
        error: getError,
        data: organiserData,
    } = useQuery(GET_ORGANISER, {
        variables: { organiserID: formData.organiserID, lang: translate.locale },
        fetchPolicy: "cache-and-network",
        onCompleted(data) {
            if (formData.organiserID != "") {
                setFormData({
                    ...formData,
                    name: data.organiser.name,
                    countryID: data.organiser.countryID,
                    sportIDs: data.organiser.sports.map((item) => item.sportID),
                });
            }
        },
    });

    const [addOrganiser, { data, loading: addLoading, error: addError }] = useMutation(ADD_EDIT_ORGANISER, {
        onCompleted(data) {
            setFormData({ ...formData, organiserID: data.addEditOrganiser.organiserID });
            props.openCloseModal(false);
            let notify = new Notification();
            notify.setNotification(translate.t("SuccessfullySaved"));

            !!props.updated && props.updated();
        },
        onError(err) {
            let notify = new Notification();
            notify.setNotification(!!err.message ? err.message : err.toStrng(), "danger");
        },
    });

    const addOrganiserData = () => {
        if (!!formData.name && formData.countryID != "0" && formData.sportIDs.length > 0) {
            let dataToSend = {
                ...formData,
            };
            addOrganiser({
                variables: {
                    addEditData: dataToSend,
                },
            });
        } else {
            let notify = new Notification();
            notify.setNotification(translate.t("NotFilledRequiredFields"), "danger");
        }
    };

    const changeSelectedSports = (item) => {
        if (formData.sportIDs.includes(item.sportID)) {
            setFormData({ ...formData, sportIDs: [...formData.sportIDs.filter((filterItem) => filterItem != item.sportID)] });
        } else {
            formData.sportIDs.push(item.sportID);
            setFormData({ ...formData, sportIDs: [...formData.sportIDs] });
        }
    };

    if (getError) {
        const helper = new Helper();
        var error = "ERROR: " + helper.getApolloErrorText(getError);
    }

    return (
        <Modal
            className="Modal__Bootstrap modal-dialog modal-lg organiser-modal"
            closeTimeoutMS={150}
            isOpen={true}
            onRequestClose={() => props.openCloseModal(false)}
        >
            <div className="modal-content">
                <div className="modal-header d-flex align-items-center">
                    <h4 className="modal-title">
                        {formData.organiserID && formData.organiserID != "" ? translate.t("EditOrganiser") : translate.t("AddOrganiser")}
                    </h4>

                    <button type="button" className="close ml-3" onClick={() => props.openCloseModal(false)}>
                        <span aria-hidden="true">x</span>
                        <span className="sr-only">Close</span>
                    </button>
                </div>
                <div className="modal-body">
                    {error ? (
                        <Error text={error} />
                    ) : (
                        <div>
                            {!getLoading && !addLoading ? (
                                <Fragment>
                                    <ul className={`nav nav-tabs`} role="tablist">
                                        <li className={`nav-item mr-2`}>
                                            <a className={`nav-link ${selectedTab == 1 ? `active` : ""}`} onClick={(e) => setTab(1)}>
                                                {translate.t("MainData")}
                                            </a>
                                        </li>
                                        <li className={`nav-item mr-2`}>
                                            <a
                                                className={`nav-link ${selectedTab == 2 ? `active` : ""}  ${!formData.organiserID ? "disabled" : ""}`}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    if (formData.organiserID) setTab(2);
                                                }}
                                            >
                                                {translate.t("Logo")}
                                            </a>
                                        </li>
                                        <li className={`nav-item mr-2`}>
                                            <a
                                                className={`nav-link ${selectedTab == 3 ? `active` : ""}  ${!formData.organiserID ? "disabled" : ""}`}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    if (formData.organiserID) setTab(3);
                                                }}
                                            >
                                                {translate.t("Contacts")}
                                            </a>
                                        </li>
                                        <li className={`nav-item mr-2`}>
                                            <a
                                                className={`nav-link ${selectedTab == 4 ? `active` : ""}  ${!formData.organiserID ? "disabled" : ""}`}
                                                onClick={(e) => {
                                                    e.preventDefault();
                                                    if (formData.organiserID) setTab(4);
                                                }}
                                            >
                                                {translate.t("UserAccounts")}
                                            </a>
                                        </li>
                                    </ul>
                                    <div className="tab-content" id="myTabContent">
                                        {selectedTab == 1 && (
                                            <>
                                                <div className="row">
                                                    <div className="col-6">
                                                        <div className="form-group">
                                                            <label className="input-label">*{translate.t("OrganiserTitle")}</label>
                                                            <div className="form-group">
                                                                <input
                                                                    className="form-control"
                                                                    type="text"
                                                                    name="title"
                                                                    value={formData.name}
                                                                    onChange={(e) => setFormData({ ...formData, name: e.target.value })}
                                                                />
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div className="col-6">
                                                        <div className="form-group">
                                                            <label className="input-label">*{translate.t("Country")}</label>
                                                            <div className="form-group">
                                                                <select
                                                                    value={formData.countryID}
                                                                    className="form-control"
                                                                    name="roleID"
                                                                    onChange={(e) => setFormData({ ...formData, countryID: e.target.value })}
                                                                >
                                                                    <option value={0}>-- {translate.t("ChooseCountry")} --</option>
                                                                    {organiserData &&
                                                                        organiserData.allCountries.map((item, index) => (
                                                                            <option key={index} value={item.countryID}>
                                                                                {item.name}
                                                                            </option>
                                                                        ))}
                                                                </select>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="card main">
                                                    <div className="card-header d-flex align-items-center">*{translate.t("Sports")}</div>
                                                    <div className="card-body">
                                                        <div className="d-flex">
                                                            {organiserData.sports.map((item, index) => (
                                                                <div className="custom-control custom-checkbox custom-control-inline" key={index}>
                                                                    <input
                                                                        type="checkbox"
                                                                        id={`sportCheckbox-${item.sportID}`}
                                                                        name="customRadioInline"
                                                                        className="custom-control-input"
                                                                        value={item.sportID}
                                                                        checked={formData.sportIDs.includes(item.sportID)}
                                                                        onChange={() => changeSelectedSports(item)}
                                                                    />
                                                                    <label className="custom-control-label" htmlFor={`sportCheckbox-${item.sportID}`}>
                                                                        {item.title}
                                                                    </label>
                                                                </div>
                                                            ))}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="d-flex justify-content-end mt-4">
                                                    <button type="button" className="btn btn-primary mr-2" onClick={() => addOrganiserData()}>
                                                        {formData.organiserID && formData.organiserID != "" ? translate.t("Edit") : translate.t("Add")}
                                                    </button>
                                                    <button type="button" className="btn btn-danger" onClick={() => props.openCloseModal(false)}>
                                                        {translate.t("Close")}
                                                    </button>
                                                </div>
                                            </>
                                        )}
                                        {selectedTab == 2 && (
                                            <EditOrganiserLogo organiserID={formData.organiserID} openCloseModal={(status) => props.openCloseModal(status)} />
                                        )}
                                        {selectedTab == 3 && (
                                            <OrganiserContactList
                                                organiserID={formData.organiserID}
                                                openCloseModal={(status) => props.openCloseModal(status)}
                                            />
                                        )}
                                        {selectedTab == 4 && (
                                            <OrganiserAdminUserList
                                                organiserID={formData.organiserID}
                                                openCloseModal={(status) => props.openCloseModal(status)}
                                            />
                                        )}
                                    </div>
                                </Fragment>
                            ) : (
                                <Loading />
                            )}
                        </div>
                    )}
                </div>
            </div>
        </Modal>
    );
};

export default AddEditOrganiser;
